import React from 'react'
import { ReactComponent as ScrapeIcon } from '../../../../../images/icons/linked_icon.svg'
import { Button, LoadingComponent, SelectInput, TextInput } from '@demandlocal/components'
import { useDealership } from '../../../../../store/zustand/dealershipStore'
import toast from 'react-hot-toast'
import { FieldValues, FormProvider, useForm } from 'react-hook-form'
import Modal from '../../../../../components/Modal/Modal'
import { useSubmitInventoryScrapeRequest } from '../../../../../api/dealership/inventory/useSubmitInventoryScrapeRequest'
import { useNavigate } from 'react-router'

export default function ConnectInventoryScrape(): JSX.Element {
  const formContext = useForm({
    mode: 'onSubmit',
  })
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = formContext

  const dealership = useDealership()

  const { mutateAsync: submitScrapeRequest } = useSubmitInventoryScrapeRequest()

  const navigate = useNavigate()

  const onSubmit = async (values: Partial<FieldValues>): Promise<void> => {
    const toastId = toast.loading('Submitting website pull request')
    try {
      await submitScrapeRequest({
        data: {
          scrape_name: values.scrape_name,
          scrape_url: values.server,
          provider: values.provider_name.value,
        },
      })
      toast.success(
        'Successfully submitted request, you should hear back about in 24 hours.',
        { id: toastId, duration: 5000 },
      )
      navigate(-1)
    } catch (err) {
      toast.error(
        'Unable to submit data provider request at this time, please contact your LinkOne representative if this problem persists.',
        { id: toastId, duration: 5000 },
      )
    }
  }

  return (
    <Modal key={'connect-inventory'} isOpen={true}>
      <FormProvider {...formContext}>
        <form
          className={
            'flex flex-1 h-full flex-col pt-12 *:px-12 relative justify-between'
          }>
          {isSubmitting && <LoadingComponent title={'Loading ...'} />}
          <div className={'flex flex-row gap-5 pb-5 items-center border-b-2'}>
            <ScrapeIcon />
            <h1 className={'text-[28px] font-bold'}>Import From Your Website</h1>
          </div>
          <div className={'p-10 rounded-lg mt-12'}>
            <div className={'flex flex-col py-10 gap-5 justify-start flex-grow'}>
              <TextInput
                name={'scrape_name'}
                label={'Website Pull Name'}
                placeholder={'Pull Name'}
                inverted
              />
              <TextInput
                name={'server'}
                label={'Enter your Dealer URL'}
                inverted
                placeholder={
                  dealership?.url
                    ? `Ex : ${dealership?.url}new-vehicles/`
                    : 'Ex : https://link1data.com/new-vehicles/'
                }
              />
              <SelectInput
                name={'provider_name'}
                label="Provider Name"
                options={[
                  { value: 'ansira', label: 'Ansira' },
                  { value: 'dealer_car_search', label: 'Dealer Car Search' },
                  { value: 'dealer_eprocess', label: 'Dealer eProcess' },
                  { value: 'dealer_inspire', label: 'Dealer Inspire' },
                  { value: 'dealer_ca', label: 'Dealer.ca' },
                  { value: 'dealer_com', label: 'Dealer.com' },
                  { value: 'dealer_fire', label: 'Dealer Fire' },
                  { value: 'dealer_on', label: 'Dealer On' },
                  { value: 'dealer_trend', label: 'Dealer Trend' },
                  { value: 'fox_dealer', label: 'Fox Dealer' },
                  { value: 'fuzion_zone', label: 'FuzionZone' },
                  { value: 'motorfuse', label: 'Motorfuse' },
                  { value: 'team_velocity', label: 'Team Velocity' },
                ]}
              />
            </div>
          </div>
          <div className={'h-20 items-center flex justify-between border-t-2 py-4'}>
            <Button
              variant={'secondary'}
              onClick={(e) => {
                e.preventDefault()
                navigate(-1)
              }}>
              Close
            </Button>
            <Button
              disabled={false}
              variant={'primary-blue'}
              onClick={(e) => {
                e.preventDefault()
                handleSubmit(onSubmit)()
              }}>
              Submit
            </Button>
          </div>
        </form>
      </FormProvider>
    </Modal>
  )
}
